import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Static fallback translations (used until API loads)
import pl from './locales/pl/translation.json';
import en from './locales/en/translation.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      pl: { translation: pl },
      en: { translation: en },
    },
    fallbackLng: 'pl',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'swibi_language',
      caches: ['localStorage'],
    },
  });

// Load translations from API (overrides static files)
async function loadFromAPI(lang) {
  try {
    const res = await fetch(`/api/translations/${lang}`);
    if (res.ok) {
      const data = await res.json();
      if (Object.keys(data).length > 0) {
        i18n.addResourceBundle(lang, 'translation', data, true, true);
      }
    }
  } catch (e) {
    // API not available, use static files
  }
}

// Load current language and fallback
const currentLang = localStorage.getItem('swibi_language') || 'pl';
loadFromAPI('pl');
if (currentLang !== 'pl') loadFromAPI(currentLang);

// Reload on language change
i18n.on('languageChanged', (lang) => {
  loadFromAPI(lang);
});

export default i18n;
